// src/components/brandCustomization/shared/TextArea.jsx
import React from 'react';

/**
 * TextArea - Textarea reutilizable
 */
const TextArea = ({
    label,
    value,
    onChange,
    placeholder = '',
    hint = null,
    rows = 4,
    maxLength = null,
    className = ''
}) => {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {label}
                    {hint && <span className="text-gray-400 ml-2 font-normal">{hint}</span>}
                </label>
            )}
            <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                rows={rows}
                maxLength={maxLength}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    );
};

export default TextArea;

